﻿/*==================================================
 *  Localization of labellers.js
 *==================================================
 */

Timeline.GregorianDateLabeller.monthNames["se"] = [
    "Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"
];

Timeline.GregorianDateLabeller.dayNames["se"] = [
    "Sön", "Mån", "Tis", "Ons", "Tors", "Fre", "Lör"
];



//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/se/labellers.js
// module id = 586
// module chunks = 3